import { FormHelperText, Grid, TextField, Switch, FormControlLabel } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { EChargeType } from 'interfaces/IEditProduct';
import { EPartnerCode } from 'interfaces/IProduct';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { run } from 'validations/ruleRunner';

import type { User } from 'v2/interfaces/user';

import Validations from './validations';
import { FormContent } from '../FormContent';
import styles from '../styles';

import type IProduct from 'interfaces/IProduct';
import type { DispatchProp } from 'react-redux';

interface IProps extends IPropsFromConnect, DispatchProp<any>, StyledComponentProps {
  loading: boolean;
  fade?: any;
  product?: IProduct;
  modifieds?: any[];
  editing?: any;
  handleChange?: any;
  copyFromOriginal?: any;
  currencyList: any;
  onChangeRequiredFields?: any;
  classes?: any;
}

interface IPropsFromConnect {
  currentUser: User;
}

interface IStates {
  showErrors: boolean;
  validationErrors: any;
  singlePaymentErrors: any;
  subscriptionErrors: any;
}

class SalesRecovery extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showErrors: false,
      validationErrors: run(props.product, Validations),
      singlePaymentErrors: {},
      subscriptionErrors: {},
    };
  }
  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };
  onChangeRequired = (name: string, fields: any) => {
    let newState = this.state;
    newState[name] = fields;
    this.setState(newState);
  };

  onChangeStates = () => {
    let { product, onChangeRequiredFields } = this.props;
    const { singlePaymentErrors, subscriptionErrors } = this.state;
    let newValidations = this.state.validationErrors;
    if (product.charge_type === EChargeType.SINGLE) {
      newValidations = { ...singlePaymentErrors, ...run(product, Validations) };
    } else if (product.charge_type === EChargeType.SUBSCRIPTION) {
      newValidations = { ...subscriptionErrors, ...run(product, Validations) };
    } else {
      newValidations = { ...run(product, Validations) };
    }
    this.setState({ validationErrors: newValidations });
    if (onChangeRequiredFields) {
      onChangeRequiredFields('salesRequiredFields', newValidations ? Object.keys(newValidations).length : 0);
    }
  };

  componentDidUpdate(prevProps: IProps) {
    if (!this.props.loading && this.props.product !== prevProps.product) {
      this.onChangeStates();
    }
  }
  componentDidMount() {
    if (!this.props.loading) {
      this.onChangeStates();
    }
  }
  render() {
    const { loading, handleChange, product, classes } = this.props;

    const isAlumy = product.cnt_partner_cod === EPartnerCode.ALUMY;
    const isOpenValue = product.charge_type === EChargeType.OTHER;

    return (
      <Grid container spacing={2} alignItems='center'>
        <Grid item xs={12}>
          <FormContent title='Recuperação de vendas' loading={loading}>
            <Grid container spacing={2} alignItems='center'>
              <Grid item xs={12}>
                <Tooltip title={isOpenValue ? '*Não é possível ativar a recuperação com Valor Aberto' : ''} placement='top'>
                  <FormControlLabel
                    label='Recuperar vendas perdidas'
                    id={'sales_recovery'}
                    disabled={isOpenValue || isAlumy}
                    control={
                      <Switch
                        color='primary'
                        checked={product.sales_recovery}
                        onChange={(e) => {
                          const bool = e.target.checked;
                          if (!bool) {
                            product.recovery_email = '';
                            handleChange('recovery_email', '');
                          }
                          return handleChange('sales_recovery', bool);
                        }}
                      />
                    }
                  />
                </Tooltip>
                <FormHelperText>
                  A Eduzz tentará recuperar vendas não concretizadas.{' '}
                  <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href='https://ajuda.eduzz.com/hc/pt-br/articles/1260807625289-Como-funciona-a-recupera%C3%A7%C3%A3o-de-vendas-perdidas-RVP-'
                  >
                    Saiba Mais
                  </a>
                </FormHelperText>
              </Grid>
              {product.sales_recovery && (
                <Grid item xs={12}>
                  <Tooltip title={'O nome definido neste campo aparecerá como remetente nos e-mails enviados de Recuperação de Vendas.'}>
                    <TextField
                      className={classes.input}
                      label='Nome do remetente de e-mail para recuperação de vendas'
                      id='recovery_email'
                      helperText={this.isValid('recovery_email') ? this.errorFor('recovery_email') : 'Ex: Fulano da Silva - Eduzz'}
                      error={this.isValid('recovery_email')}
                      fullWidth
                      value={product.recovery_email}
                      onChange={(e: any) => handleChange('recovery_email', e.target.value)}
                      disabled={!product.sales_recovery}
                      InputProps={{
                        disableUnderline: true,
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      // disabled={isAlumy}
                    />
                  </Tooltip>
                </Grid>
              )}
            </Grid>
          </FormContent>
        </Grid>
      </Grid>
    );
  }
}
function mapStateToProps(state: any) {
  return {
    currentUser: state.orbita.User.user.user,
  };
}

export default connect(mapStateToProps)(styles(SalesRecovery));
